// ======================================================================
// File Name       : superuserServiceRole
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SUPERUSER_SERVICE_ROLE_RECEIVE_LIST } from '../constants/ActionTypes';

const initialState = {
  authorityInfo: {
    roleList: [],
    bySecernId: {},
  },
};

export default function authority(state = initialState, action) {
  switch (action.type) {
    case SUPERUSER_SERVICE_ROLE_RECEIVE_LIST: {
      const { roleList } = action;
      const authorityInfo = roleList.reduce(
        (acc, cur) => {
          const { superuserServiceRoleSecernId } = cur;
          acc.bySecernId[superuserServiceRoleSecernId] = cur;
          return acc;
        },
        { bySecernId: {}, roleList },
      );
      return { ...state, authorityInfo };
    }

    default:
      return state;
  }
}
